/**
 * 404 Not Found page component.
 *
 * @module pages/NotFoundPage
 */

import { Link } from 'react-router';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';

/**
 * 404 Not Found page
 */
export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <h1 className="text-9xl font-bold text-gray-200">404</h1>
      <h2 className="mt-4 text-2xl font-semibold text-gray-900">Page Not Found</h2>
      <p className="mt-2 text-gray-500 max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div className="mt-8 flex gap-4">
        <Button
          variant="secondary"
          leftIcon={<ArrowLeft className="h-4 w-4" />}
          onClick={() => window.history.back()}
        >
          Go Back
        </Button>
        <Link to="/dashboard">
          <Button leftIcon={<Home className="h-4 w-4" />}>Go to Dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
